import React from "react";
import { SRLWrapper } from "simple-react-lightbox";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import data from "../../data/product.json";
import PortfolioOne from "./PortfolioOne";
import Spacer3 from "../common/Spacer3";

function Urunlerimiz({ isPage = false }) {
  const { t } = useTranslation();

  return (
    <SRLWrapper>
      <section
        id="portfolio"
        className="portfolio"
        aria-labelledby="products-title"
        style={{
          marginTop: "5rem",
          padding: "0rem 1.5rem 1.5rem 1.5rem",
        }}
      >
        <Spacer3 />

        <Container data-aos="fade-up">
          <div className="section-title">
            {isPage ? (
              <h1 id="products-title">
                {t("ÜRÜNLERİMİZ")}
              </h1>
            ) : (
              <h2 id="products-title">
                {t("ÜRÜNLERİMİZ")}
              </h2>
            )}
          </div>

          <Row>
            {data.map((product) => {
              const { picture, nav, id } = product;

              const title = t(product.title);
              const desc = t(product.desc);

              return (
                <Col
                  lg={3}
                  md={6}
                  sm={12}
                  key={id}
                  className="text-center mb-5"
                >
                  <PortfolioOne
                    picture={picture}
                    title={title}
                    desc={desc}
                    nav={nav}
                  />
                </Col>
              );
            })}
          </Row>
        </Container>
      </section>
    </SRLWrapper>
  );
}

export default Urunlerimiz;